module.exports = __webpack_public_path__ + "img/guo-da-nian.d8b28526.jpeg";